import ClientSettings from "@/components/users/clientedit/ClientSettings";
import Users from "@/components/users/Users";

export default [
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/clientSettings",
    name: "ClientSettings",
    component: ClientSettings,
    meta: {
      requiresAuthentication: true
    }
  }
];
